import { render } from "./EventCard.vue?vue&type=template&id=43c7b67d&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=ts"
export * from "./EventCard.vue?vue&type=script&lang=ts"

import "./EventCard.vue?vue&type=style&index=0&id=43c7b67d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43c7b67d"

export default script